const actions = {
  SET_STATE: 'student/SET_STATE',
  SOME_FUNCTION: 'studnet/SOME_FUNCTION',
  STUDENT_DETAILS: 'student/STUDENT_DETAILS',
  SET_DRAWER_WIDTH: 'student/SET_DRAWER_WIDTH',
  GET_STUDENT_SESSION: 'student/GET_STUDENT_SESSION',
}

export default actions
